/* FIXME: This file will need to implement translations once the useDashboardReskinExperiment is implemented outside the US */
import type { JSX } from 'react';

// eslint-disable-next-line @change/sibling-module-imports
import { SHARE_BUTTON_CONFIG } from 'src/app/pages/starterDashboardV2/shared/hooks/useTriggerSharePetitionModal/useDashboardShareActions/constants';

import { SharePetitionButton } from './components/SharePetitionButton/index_new';
import { useShareSocial } from './hooks/useShareSocial/index_new';

type ShareSocialProps = {
	className?: string;
};

export function ShareSocial({ className }: ShareSocialProps): JSX.Element {
	const actions = useShareSocial();

	return (
		<div className={className}>
			{actions.map(({ action, channel }) => {
				const { label, successLabel } = SHARE_BUTTON_CONFIG[channel];
				return (
					<div
						data-testid={`share-social-${channel.toLowerCase()}`}
						key={channel}
						className="sm:w-1/4 [@media(min-width:1204px)]:flex-1 [@media(min-width:1204px)]:justify-items-center"
					>
						<SharePetitionButton
							data-qa={`share-social-${channel.toLowerCase()}`}
							channel={channel}
							action={action}
							label={label}
							successLabel={successLabel}
						/>
					</div>
				);
			})}
		</div>
	);
}
